import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import { ThemeProvider } from './contexts/ThemeContext';
import { ThemeToggle, ScrollToTop, CookieConsent } from './components/common';
import FuelQuoteForm from './components/FuelQuoteForm';
import QuotesScreen from './components/QuotesScreen';
import SupplyContractTerms from './components/SupplyContractTerms';
import TermsOfUse from './components/TermsOfUse';
import PrivacyPolicy from './components/PrivacyPolicy';
import { setupCSPReporting } from './utils/cspReporter';
import { initializeMatomoAnalytics } from './utils/matomoAnalytics';

function AppContent() {
return (
        <>
            <ScrollToTop />
            <main id="main-content" role="main" aria-label="Main application content">
                <Routes>
                    <Route path="/" element={<FuelQuoteForm />} />
                    <Route path="/quotes" element={<QuotesScreen />} />
                    <Route path="/supply-contract-terms" element={<SupplyContractTerms />} />
                    <Route path="/terms-of-use" element={<TermsOfUse />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                </Routes>
            </main>
            <CookieConsent />
        </>
    );
}

function App() {
// Initialize CSP violation reporting and Matomo Analytics
useEffect(() => {
    setupCSPReporting();
    initializeMatomoAnalytics();
}, []);

return (
        <ThemeProvider>
            <div className="App" role="application" aria-label="ENGIE Business Energy Quote Application">
                {/* Skip to main content link for screen readers */}
                <a
                    href="#main-content"
                    className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:px-4 focus:py-2 focus:bg-blue-600 focus:text-white focus:rounded"
                    aria-label="Skip to main content"
                >
                    Skip to main content
                </a>

                {/* Floating Theme Toggle - always accessible */}
                <aside
                    className="themeToggleContainer"
                    aria-label="Theme settings"
                >
                    <ThemeToggle />
                </aside>

                <Router>
                    <AppContent />
                </Router>
            </div>
        </ThemeProvider>
    );
}

export default App;
